'use strict';

let packagenamePass = (rule, value, callback) => {
    let reg = /^[\w][\w\d]*([.][\w][\w\d]*)+$/;
    if(value){
        reg.test(value) ?  callback() : callback(new Error("格式错误,例如com.mapbar.com"));
    };
};
let deviceIdListPass = (rule, value, callback) => {
    if(value.some(item => { return item == ''})){
        callback(new Error("不可为空"));
    }else{
        callback();
    }
}

function getRules() {
    return {
        company:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        name:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        uploadMesList:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],


    };
}
export {
    getRules
}
